// extracted by mini-css-extract-plugin
export default {"deal_product_input":"deal-product-input_deal_product_input__RHcka"};